import { makeStyles } from "@material-ui/core/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import { withTranslation } from "react-i18next";
import i18n from "../../utils/LanguageSelector/i18n";
import "./Tracker.scss";

const useStyles = makeStyles({
  root: {
    height: "12px",
    flexGrow: 1,
    backgroundColor: "transparent",
  },
});

function Tracker({ activeStep, steps, id }) {
  const classes = useStyles();
  const TrackerLabels = {
    get cargo() {
      return i18n.t("tracker.1");
    },
    get serviceinfo() {
      return i18n.t("tracker.2");
    },
    get details() {
      return i18n.t("tracker.3");
    },
  };
  return (
    <div>
      <span className="TrackerLabel">{TrackerLabels[id]}</span>
      <MobileStepper
        variant="progress"
        steps={steps}
        position="static"
        activeStep={activeStep}
        className={classes.root}
      />
    </div>
  );
}

export default withTranslation()(Tracker);
